import AskForAPNPermission from '@/vcs/_shared/modals/ask-for-apn-permission/cmp.vue'

export default {
  methods: {
    startFlowAPN() {
      // we rescue this permission, there must me interaction
      let apn_permission = localStorage.getItem('apn_permission')
      if (apn_permission != 'set') {
        this.$store.commit('modal/open', {
          cmp: AskForAPNPermission,
          animation: 'slide-left-modal',
          data: {},
        })
      } else {
        console.log(
          '%c SAFARI NOTIFICATION PERMISSION ALREADY SET',
          'color: #e01a66; font-weight: bold;',
        )
      }
    },
  },
}
